import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import { Flex, Box, Text } from "rebass";
import Img from "react-image";

import { metaDataProps } from "../pages/index";
import FacebookButton from "./ui/FacebookButton";
import MobileNav from "./MobileNav/MobileNav";
import logo from "../img/logo.png";
import fbIcon from "../img/facebook-icon.svg";

type Props = {
  siteMetadata: metaDataProps,
  user: { demoLinkRef: string }
};

export const navLinks = [
  // {
  //   label: "Why",
  //   path: "/why"
  // },
  {
    label: "Pricing",
    path: "/pricing"
  },
  {
    label: "Contact",
    path: "/contact"
  }
];

const Navbar = ({ siteMetadata, user }: Props) => (
  <NavBar>
    <div className="container">
      <Flex align="center">
        <LogoBox mr={[0, 0, "25px"]}>
          <Logo to="/" is={Link}>
            <img src={logo} alt="Pipeline" height="27" />
          </Logo>
        </LogoBox>

        <NavItems w={["340px"]} mr={[0, 0, "auto"]}>
          <Flex align="center">
            {navLinks.map((link, i) => (
              <NavBox pr={[2, 2, "10px"]} pl={i === 0 ? 0 : "10px"} key={i}>
                <NavLink to={link.path}>{link.label}</NavLink>
              </NavBox>
            ))}
          </Flex>
        </NavItems>

        <ControlBox>
          <LoginLink href={siteMetadata.appUrl} mb={[0, 2, 3, 4]}>
            Login with <StyledFbIcon src={fbIcon} />
          </LoginLink>
        </ControlBox>

        {user && (
          <ControlBox ml={[3]}>
            <StyledMessengerButton
              is="a"
              href={user.demoLink}
              type="messenger"
              mb={[0, 2, 3, 4]}
              target="_blank"
            >
              Try Live Demo
            </StyledMessengerButton>
          </ControlBox>
        )}

        <MobileNav siteMetadata={siteMetadata} user={user} />
      </Flex>
    </div>
  </NavBar>
);

export default Navbar;

// Styled Components
const NavBar = styled.nav`
  height: 56px;
  position: relative;
  z-index: 2;

  @media (min-width: 48em) {
    height: auto;
    margin-bottom: 20px;
    padding: 20px 0 0;
  }
`;

const NavItems = styled(Box)`
  display: none;

  @media (min-width: 48em) {
    display: block;
  }
`;

const NavBox = styled(Box)`
  height: 54px;
  line-height: 54px;
  text-align: center;
  text-shadow: 1px 1px #fafafa;
`;

const LogoBox = NavBox.extend`
  line-height: 56px;
`;

const NavLink = styled(Link)`
  font-size: 14px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: 52em) {
    font-size: 15px;
  }
`;

const LoginLink = styled.a`
  color: ${p => p.theme.colors.facebookBlue};
  font-family: "Open Sans", "Helvetica", "Arial", sans-serif;
  font-size: 15px;
  font-weight: 400;
  text-decoration: none;

  &:visited {
    color: ${p => p.theme.colors.facebookBlue};
  }
`;

const StyledFbIcon = styled(Img)`
  margin-left: 3px;
  position: relative;
  top: 3px;
  width: 19px;
`;

const StyledFacebookButton = styled(FacebookButton)`
  color: #fff !important;
  font-size: 13px;
  margin: 0;
  padding: 13px 15px 13px;
  text-transform: uppercase;

  svg {
    position: relative;
    top: -1px;
  }
`;

const StyledMessengerButton = StyledFacebookButton.extend`
  height: 45px;
  padding: 11px 15px 13px;

  img {
    top: 3.9px;
    width: 13px;
  }
`;

const Logo = styled(Text)`
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  color: ${p => p.theme.colors.support2}!important;
  font-family: "PT Sans", sans-serif;
  font-weight: 600;
  text-decoration: none;
  text-shadow: 1px 1px #fafafa;
  user-select: none;

  img {
    margin: 17px 0 0;
  }
`;

const ControlBox = styled(Box)`
  display: none;
  text-align: right;

  @media (min-width: 48em) {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx